<template>
  <v-dialog
    v-model="innerValue"
    transition="dialog-transition"
    :persistent="persistent"
    eager
    scrollable
    v-bind="$attrs"
    v-on="$listeners"
    :width="width"
  >
    <slot name="all">
      <v-card>
        <v-toolbar color="primary lighten-1" dark dense flat>
          <v-toolbar-title> {{ title }} </v-toolbar-title>
        </v-toolbar>
        <v-card-text >
          <slot name="default"></slot>
        </v-card-text>
        <!-- 버튼 영역 START -->
        <v-divider></v-divider>
        <v-card-actions>
          <slot name="actions">
            <v-spacer></v-spacer>
            <rx-btn color="grey" outlined @click="close" tile class="ma-1">
              <v-icon left>$vuetify.icons.btn_cancel</v-icon>
              {{ $t("common.btn.close") }}
            </rx-btn>
          </slot>
          <!-- 버튼 영역 START -->
        </v-card-actions>
      </v-card>
    </slot>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: "600",
    },
    title: {
      type: String,
      default: "",
    },
    persistent: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      innerValue: this.value,
    };
  },
  methods: {
    close() {
      this.innerValue = false;
      this.$emit("close");
    },
  },
  watch: {
    innerValue() {
      this.$emit("input", this.innerValue);
    },
    value() {
      this.innerValue = this.value;
    },
  }
}
</script>